export const REGEX_PATTERN = {
  INTEGER: '^[0-9]+$',
  MORE_THAN_ZERO: '^(0*[1-9][0-9]*(.[0-9]+)?|0+.[0-9]*[1-9][0-9]*)$'
}
